export default __webpack_public_path__ + "static/media/tea.b68dfb17.png";